<template>
    <div>
        <template v-for="[filter, values] of Object.entries(selectedFilterValues)">
            <template v-if="getFilter(filter).type !== 'range-slider'">
                <v-chip
                    @click="deselectFilterValue(filter, filterValue)"
                    label
                    class="mr-1 my-1"
                    close
                    outlined
                    v-for="filterValue of values"
                    :key="filterValue"
                >
                    {{ getFilter(filter).displayName }}: {{ formatFilterValue(filter, filterValue) }}
                    <v-icon color="grey" small right>
                        {{ mdiClose }}
                    </v-icon>
                </v-chip>
            </template>

            <v-chip @click="deselectFilter(filter)" v-else :key="filter" label class="mr-1 my-1" close outlined>
                {{ getFilter(filter).displayName }}: {{ formatRange(filter, values) }}
                <v-icon color="grey" small right>
                    {{ mdiClose }}
                </v-icon>
            </v-chip>
        </template>

        <v-chip v-if="Object.keys(selectedFilterValues).length > 0" label class="mr-1 my-1" color="secondary" @click="deselectAll()">
            {{ $t('removeAllFilters') }}
        </v-chip>
    </div>
</template>

<script lang="ts">
import { mdiClose } from '@mdi/js';
import { Vue } from 'vue-property-decorator';
import { PropType } from 'vue';
import { Params, RangeSliderValues } from '../../api/api';
import { omit as _omit, without as _without } from 'lodash-es';
import { Filter, FINDOLOGICSearchAPIJSONResponse10 } from '../../../../declarations/result';
import ComponentUtils from '../../../LayoutAssistedSuggest/services/ComponentUtils';

export default Vue.extend({
    name: 'SelectedFilters',
    props: {
        value: {
            type: Object as PropType<Params['attrib']>,
            default() {
                return {};
            },
        },
        filters: {
            type: Object as PropType<FINDOLOGICSearchAPIJSONResponse10['result']['filters']>,
            required: true,
        },
    },
    methods: {
        deselectFilterValue(filter: string, value: string): void {
            this.selectedFilterValues = {
                ...this.selectedFilterValues,
                ...{ [filter]: _without(this.selectedFilterValues[filter] as ArrayLike<any>, value) },
            };
        },
        deselectFilter(filter: string): void {
            this.selectedFilterValues = _omit(this.selectedFilterValues, filter);
        },
        deselectAll(): void {
            this.selectedFilterValues = {};
        },
        getFilter(filterName: string): Filter | undefined {
            return this.allFilters.find((filter: Filter) => filter.name === filterName);
        },
        formatFilterValue(filter: string, value: string): string {
            switch (filter) {
                case 'cat':
                    return value.replaceAll('_', ' → ');
                default:
                    return value;
            }
        },
        formatRange(filterName: string, value: RangeSliderValues): string {
            const unit = this.getFilter(filterName).unit || '';

            if (filterName === 'price') {
                const componentUtils = new ComponentUtils();
                const min = componentUtils.formatPrice(value.min);
                const max = componentUtils.formatPrice(value.max);

                return `${min} - ${max}`;
            }

            const nf = new Intl.NumberFormat(window.navigator.language, {
                style: 'decimal',
            });

            return `${nf.format(value.min)}${unit} - ${nf.format(value.max)}${unit}`;
        },
    },
    computed: {
        selectedFilterValues: {
            get(): Params['attrib'] {
                return _omit(this.value, 'cat_url');
            },
            set(selectedFilterValues: Params['attrib']) {
                this.$emit('input', selectedFilterValues);
            },
        },
        allFilters(): Filter[] {
            return [...this.filters.main, ...this.filters.other];
        },
    },
    data() {
        return {
            mdiClose,
        };
    },
});
</script>

<style scoped></style>
